var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppointments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 109,
    height: 94,
    viewBox: "0 0 109 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.27124 27.6094H103.717",
    stroke: "#0054A6",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4572 40.8574H21.7927V51.3258H32.4572V40.8574Z",
    stroke: "#0054A6",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60.241 40.8574H49.5765V51.3258H60.241V40.8574Z",
    stroke: "#0054A6",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M88.0249 40.8574H77.3604V51.3258H88.0249V40.8574Z",
    stroke: "#0054A6",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4572 64.8125H21.7927V75.2809H32.4572V64.8125Z",
    stroke: "#0054A6",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M60.241 64.8125H49.5765V75.2809H60.241V64.8125Z",
    stroke: "#0054A6",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M88.0249 64.8125H77.3604V75.2809H88.0249V64.8125Z",
    stroke: "#0054A6",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M98.3721 2.39648H10.6279C6.10606 2.39648 2.44038 5.99475 2.44038 10.4334V83.5685C2.44038 88.0072 6.10606 91.6054 10.6279 91.6054H98.3721C102.894 91.6054 106.56 88.0072 106.56 83.5685V10.4334C106.56 5.99475 102.894 2.39648 98.3721 2.39648Z",
    stroke: "#0054A6",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppointments);
export default __webpack_public_path__ + "static/media/appointments.3e48377141a21d00539acbdd2d657107.svg";
export { ForwardRef as ReactComponent };